<template>
  <v-card>
    <v-container fluid>
      <v-row dense>
        <v-col class="text-h5">
          {{ presentation.name }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="authorization" class="mr-2" v-bind="attrs" v-on="on">
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar apresentação</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="presentation.name"
                          label="Nome"
                          :hide-details="!errors.presentation"
                          :error-messages="errors.presentation"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" @click="deletePresentation">
              eva-trash-outline
            </v-icon>
          </authorization>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-row>
            <v-col>
              <PresentationUnityTable :presentation="presentation" :refreshList="refreshList" />
            </v-col>
          </v-row>

          <v-divider />

          <v-row>
            <v-col>
              <PresentationActionTable
                :presentation="presentation"
                :refreshList="refreshList"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import PresentationUnityTable from "@/components/config/medicine/presentation/item/presentation_unity_table.vue";
  import PresentationActionTable from "@/components/config/medicine/presentation/item/presentation_action_table.vue";

  export default {
    name: "PresentationListItem",
    props: {
      presentation: Object,
      refreshList: Function,
    },
    components: {
      PresentationUnityTable,
      PresentationActionTable,
    },
    data() {
      return {
        errors: {},
        dialog: null,
      };
    },
    methods: {
      deletePresentation() {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medicine/delete_presentation.gql"),
            variables: {
              presentationId: this.presentation.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/medicine/save_presentation.gql"),
          variables: {
            presentationId: this.presentation.id,
            name: this.presentation.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.presentation.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.presentation = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
